<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>{{ this.titlePage }}</strong>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="position"
                label="Position"
                color="red darken-1"
                required
              ></v-text-field>
              <v-autocomplete
                v-model="type"
                :items="typeList"
                :loading="isPreparingForm"
                item-value="EMPLOYEE_TYPE_CODE"
                item-text="EMPLOYEE_TYPE_CODE"
                :return-object="true"
                label="Type"
                color="red darken-1"
                @change="getSupervisor()"
              ></v-autocomplete>
              <v-autocomplete
                v-model="title"
                :items="titleList"
                :loading="isPreparingTitleList"
                item-value="EMPLOYEE_TITLE_CODE"
                item-text="EMPLOYEE_TITLE_CODE"
                :return-object="true"
                label="Title"
                color="red darken-1"
              ></v-autocomplete>
              <v-row dense>
                <!-- START DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        color="red darken-1"
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="isShowStartDate = false"
                      color="red darken-1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- END DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        color="red darken-1"
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @input="isShowEndDate = false"
                      color="red darken-1"
                    >
                      <template>
                        <v-card-actions class="w-100 float-right">
                          <v-btn
                            small
                            color="warning"
                            @click="setEndDateOfThisMonth()"
                            >Select End Date of This Month</v-btn
                          >
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-autocomplete
                v-model="branch"
                :items="branchList"
                :loading="isPreparingForm"
                item-value="BRANCH_CODE"
                item-text="BRANCH_CODE"
                :return-object="true"
                label="Branch"
                color="red darken-1"
                @change="getSupervisor()"
              ></v-autocomplete>
              <v-autocomplete
                v-model="supervisor"
                :items="supervisorList"
                :loading="isPreparingSPV"
                item-text="ROLE_POSITION_CODE"
                :return-object="true"
                label="Supervisor"
                color="red darken-1"
                @change="getEmailSupervisor()"
              ></v-autocomplete>
              <v-autocomplete
                v-model="CSOCode"
                :items="CSOList"
                :loading="isPreparingCSO"
                item-text="ROLE_POSITION_CODE"
                :return-object="true"
                label="CSO"
                color="red darken-1"
              ></v-autocomplete>
              <v-text-field
                v-model="emailSupervisor"
                :rules="[rules.email]"
                label="Email Supervisor"
                color="red darken-1"
              ></v-text-field>
              <!-- START - Edited by Dedian 29 Juli 2021 -->
              <v-autocomplete
                v-model="collector"
                :items="collectorList"
                item-value="CODE_COLLECTOR"
                item-text="CODE_COLLECTOR"
                label="Collector"
                color="red darken-1"
              ></v-autocomplete>
              <!-- END - Edited by Dedian 29 Juli 2021 -->
              <v-autocomplete
                v-model="secondaryposition"
                :items="secondarypositionList"
                item-value="CODE_SEC_POSITION"
                item-text="CODE_SEC_POSITION"
                label="Secondary Position"
                color="red darken-1"
              ></v-autocomplete>
              <v-autocomplete
                v-if="isSecondaryPosition"
                v-model="mappingsalesrep"
                :items="mappingsalesrepList"
                item-text="CODE_MAPPING_SALESREP"
                label="Mapping Additional"
                color="red darken-1"
              ></v-autocomplete>
              <v-autocomplete
                v-if="isMappingSalesRep"
                v-model="additionalType"
                :items="additionalTypeList"
                item-text="ROLE_POSITION_CODE"
                item-value="ROLE_POSITION_CODE"
                label="Additional Type"
                color="red darken-1"
              ></v-autocomplete>
              <!--<v-text-field v-if="isMappingSalesRep" v-model="additionalType" label="Additional Type" required></v-text-field>-->
              <v-btn
                @click="confirmModal(submit)"
                color="warning"
                class="mt-6"
                >{{ this.titlePage }}</v-btn
              >
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give
          confirmation before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

export default {
  components: {
    Main,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      valid: true,
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      endDate: moment("4001-12-31").endOf("month").format("YYYY-MM-DD"),
      isShowEndDate: false,
      isPreparingForm: false,
      isPreparingSPV: false,
      isPreparingCSO: false,
      position: "",
      emailSupervisor: "",
      type: null,
      title: null,
      branch: null,
      supervisor: "",
      CSOCode: "NA",
      collector: "N",
      secondaryposition: "N",
      additionalType: "",
      additionalTypeList: "",
      rules: {
          // required: value => !!value || 'Required.',
          // counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            // console.log("ini isi nya => ", value);
            // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const validValue = value.replace(" ",";");
            this.emailSupervisor = validValue;
            return validValue
          },
        },
      CSOList: [
        {
          ROLE_POSITION_CODE: "NA",
        },
      ],
      branchList: [],
      titleList: [],
      typeList: [],
      roleMapID: "",
      supervisorList: [
        {
          ROLE_POSITION_CODE: "NA",
        },
      ],
      collectorList: [
        {
          CODE_COLLECTOR: "Y",
        },
        {
          CODE_COLLECTOR: "N",
        },
      ],
      secondarypositionList: [
        {
          CODE_SEC_POSITION: "Y",
        },
        {
          CODE_SEC_POSITION: "N",
        },
      ],
      mappingsalesrepList: [
        {
          CODE_MAPPING_SALESREP: "Yes",
        },
        {
          CODE_MAPPING_SALESREP: "No",
        },
      ],
      mappingsalesrep: "No",
      isSecondaryPosition: true,
      isMappingSalesRep: false,
      isPreparingTitleList: false,
      titlePage: "Add New Role",
    };
  },
  mounted() {
    if (this.$route.params.roleMapID) {
      this.getRoleById(this.$route.params.roleMapID);
      this.titlePage = "Edit Structure Role";
    } else {
      this.prepareForm();
    }
  },
  watch: {
    $route(to) {
      if (to.params.roleMapID) {
        this.getRoleById(to.params.roleMapID);
        this.titlePage = "Edit Structure Role";
      }
    },
    // whenever question changes, this function will run
    mappingsalesrep: function (newmappingsalesrepList, oldmappingsalesrepList) {
      if (newmappingsalesrepList == "Yes") {
        this.isMappingSalesRep = true;

        if (this.branch) {
          this.$http
            .post("/structure/role/selectAdditionalType", {
              branchCode: this.branch.BRANCH_CODE || this.branch,
            }, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              console.log(res);
              if (!res.data.success || res.data.success == undefined) {
              }
              const { data } = res.data;
              this.additionalTypeList = data;
            })
            .catch((err) => {
              this.isPreparingForm = false;
              this.showSnackbar(err.toString());
            });
        } else {
          this.additionalTypeList = [
            {
              ROLE_POSITION_CODE:
                "ISI DAHULU BRANCH CODE LALU UBAH MAPPING ADDITIONAL KE NO LALU YES KEMBALI",
            },
          ];
        }
      } else {
        this.isMappingSalesRep = false;
        this.additionalType = "NA";
      }
    },
    secondaryposition: function (newsecpositionList, oldsecpositionList) {
      if (newsecpositionList == "Y") {
        this.isSecondaryPosition = false;
        this.isMappingSalesRep = false;
        this.mappingsalesrep = "No";
        this.additionalType = "NA";
      } else {
        this.isSecondaryPosition = true;
        this.isMappingSalesRep = false;
      }
    },
  },
  methods: {
    prepareForm(BRANCH_CODE, EMPLOYEE_TYPE_CODE) {
      this.isPreparingForm = true;
      this.$http
        .get("/structure/role/prepareForm", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          console.log(res);
          const { data } = res.data;

          if (this.$route.params.roleMapID) {
            const selectedBranchList = data.branchList.find((x) => {
              return x.BRANCH_CODE === BRANCH_CODE;
            });
            this.branch = selectedBranchList;

            const selectedTypeList = data.typeList.find((x) => {
              return x.EMPLOYEE_TYPE_CODE === EMPLOYEE_TYPE_CODE;
            });
            this.type = selectedTypeList;
          }

          this.typeList = data.typeList;
          this.branchList = data.branchList;
          this.isPreparingForm = false;
        })
        .catch((err) => {
          this.isPreparingForm = false;
          this.showSnackbar(err.toString());
        });
    },
    getRoleById(id) {
      window.scrollTo(0, 0);
      this.isLoading = true;
      this.$http
        .get(`/structure/role/${id}`, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          console.log(res);
          this.isLoading = false;
          const { data, success } = res.data;
          console.log(`/structure/role/${id}`, data);
          if (success) {
            this.prepareForm(data.BRANCH_CODE, data.EMPLOYEE_TYPE_CODE);
            this.titleList = [];
            this.isPreparingTitleList = true;
            this.$http
              .post("/structure/role/getTitleByType", {
                typeCode: data.EMPLOYEE_TYPE_CODE,
              }, {
                headers: {
                  "api-key": this.$apiKey
                }
              })
              .then((res) => {
                console.log(res);
                this.titleList = res.data.data;
                this.isPreparingTitleList = false;
                const selectedTitleList = res.data.data.find((x) => {
                  return x.EMPLOYEE_TITLE_CODE === data.EMPLOYEE_TITLE_CODE;
                });
                this.title = selectedTitleList;
              })
              .catch((err) => {
                this.isPreparingTitleList = false;
                this.showSnackbar(err.toString());
              });

            this.supervisorList = [];
            this.emailSupervisor = "";
            this.isPreparingSPV = true;
            this.$http
              .post("/structure/role/getSupervisorbyBranch", {
                branchCode: data.BRANCH_CODE,
              }, {
                headers: {
                  "api-key": this.$apiKey
                }
              })
              .then((res) => {
                console.log(res);
                const { data } = res.data;
                this.supervisorList = data;
                this.isPreparingSPV = false;
              })
              .catch((err) => {
                this.isPreparingSPV = false;
                this.showSnackbar(err.toString());
              });

            this.roleMapID = data.ROLE_MAP_ID;
            this.position = data.ROLE_POSITION_CODE;
            this.startDate = moment(data.ROLE_START_DATE).format("YYYY-MM-DD");
            // // console.log(data.ROLE_START_DATE, " - ", this.startDate)

            this.endDate = moment(data.ROLE_END_DATE).format("YYYY-MM-DD");
            // // console.log(data.ROLE_END_DATE, " - ", this.endDate)

            this.supervisor = {
              ROLE_POSITION_CODE: data.ROLE_SUP_CODE,
            };
            this.emailSupervisor = data.SUPERVISOR_EMAIL;

            this.isPreparingCSO = true;
            this.$http
              .post("/structure/role/getCSOListByBranch", {
                branchCode: data.BRANCH_CODE,
              }, {
                headers: {
                  "api-key": this.$apiKey
                }
              })
              .then((res) => {
                console.log(res);
                const { data } = res.data;
                this.CSOList = data;
                this.isPreparingCSO = false;
              })
              .catch((err) => {
                this.isPreparingCSO = false;
                this.showSnackbar(err.toString());
              });

            if (data.CSO_CODE) {
              this.CSOCode = {
                ROLE_POSITION_CODE: data.CSO_CODE,
              };
            } else {
              this.CSOCode = {
                ROLE_POSITION_CODE: "NA",
              };
            }

            this.collector = data.IS_COLECTOR;
            // console.log("SECONDARY_POSITION : ", data);
            this.secondaryposition = data.SECONDARY_POSITION;

            if (
              data.ROLE_ADD_TYPE_CODE == "NA" ||
              data.ROLE_ADD_TYPE_CODE == "-" ||
              data.ROLE_ADD_TYPE_CODE == ""
            ) {
              this.mappingsalesrep = "No";
              this.additionalType = "NA";
            } else {
              this.mappingsalesrep = "Yes";
              this.additionalType = data.ROLE_ADD_TYPE_CODE;
            }

            this.additionalType = data.ROLE_ADD_TYPE_CODE;
            this.$http
              .post("/structure/role/selectAdditionalType", {
                branchCode: data.BRANCH_CODE,
              }, {
                headers: {
                  "api-key": this.$apiKey
                }
              })
              .then((res) => {
                console.log(res);
                const { data } = res.data;
                this.additionalTypeList = data;
              })
              .catch((err) => {
                this.isPreparingForm = false;
                this.showSnackbar(err.toString());
              });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          // console.log("error getStructureTitleById", err.toString());
        });
    },
    setEndDateOfThisMonth: function () {
      this.endDate = moment().endOf("month").format("YYYY-MM-DD");
      this.isShowEndDate = false;
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    getSupervisor() {
      // // console.log(this.type)

      if (this.type) {
        this.titleList = [];
        this.isPreparingTitleList = true;
        this.$http
          .post("/structure/role/getTitleByType", {
            typeCode: this.type.EMPLOYEE_TYPE_CODE,
          }, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res);
            const { data } = res.data;
            this.titleList = data;
            this.isPreparingTitleList = false;
          })
          .catch((err) => {
            this.isPreparingTitleList = false;
            this.showSnackbar(err.toString());
          });

        if (
          this.type.EMPLOYEE_TYPE_CODE == "SUP" ||
          this.type.EMPLOYEE_TYPE_CODE == "SUPERVISOR"
        ) {
          this.supervisorList = [
            {
              ROLE_POSITION_CODE: "NA",
            },
          ];
          this.supervisor = {
            ROLE_POSITION_CODE: "NA",
          };
        } else {
          this.supervisorList = [];
          this.emailSupervisor = "";
          this.isPreparingSPV = true;
          this.$http
            .post("/structure/role/getSupervisorbyBranch", {
              branchCode: this.branch.BRANCH_CODE,
            }, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              console.log(res);
              const { data } = res.data;
              this.supervisorList = data;
              this.isPreparingSPV = false;
              this.supervisor = {
                ROLE_POSITION_CODE: "NA",
              };
            })
            .catch((err) => {
              this.isPreparingSPV = false;
              this.showSnackbar(err.toString());
            });
        }
      }

      if (this.branch) {
        this.isPreparingCSO = true;
        this.$http
          .post("/structure/role/getCSOListByBranch", {
            branchCode: this.branch.BRANCH_CODE,
          }, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res);
            const { data } = res.data;
            this.CSOList = data;
            this.isPreparingCSO = false;
            this.CSOCode = {
              ROLE_POSITION_CODE: "NA",
            };
          })
          .catch((err) => {
            this.isPreparingCSO = false;
            this.showSnackbar(err.toString());
          });
      }
    },
    getEmailSupervisor() {
      // // console.log(this.supervisor)
      this.emailSupervisor = this.supervisor.SUPERVISOR_EMAIL;
    },
    submit() {
      this.isOpenModalConfirm = false;
      this.isLoading = true;
      const userData = JSON.parse(localStorage.getItem("userData"));

      if (this.$route.params.roleMapID) {
        const data = {
          ROLEMAPID: this.roleMapID,
          ROLEPOSITIONCODE: this.position,
          EMPLOYEETYPEID: this.type.EMPLOYEE_TYPE_ID,
          EMPLOYEETYPECODE: this.type.EMPLOYEE_TYPE_CODE,
          EMPLOYEETITLEID: this.title.EMPLOYEE_TITLE_ID,
          EMPLOYEETITLECODE: this.title.EMPLOYEE_TITLE_CODE,
          ORGID: this.branch.ORG_ID,
          BRANCHCODE: this.branch.BRANCH_CODE,
          CSOCODE: this.CSOCode.ROLE_POSITION_CODE
            ? this.CSOCode.ROLE_POSITION_CODE
            : "NA",
          ROLESUPCODE: this.supervisor.ROLE_POSITION_CODE
            ? this.supervisor.ROLE_POSITION_CODE
            : "NA",
          ROLEADDTYPECODE:
            this.additionalType ||
            this.additionalType != "" ||
            this.additionalType != "-"
              ? this.additionalType
              : "NA",
          SUPERVISOREMAIL: this.emailSupervisor ? this.emailSupervisor : "NA",
          COLLECTOR: this.collector,
          SECONDARYPOSITION: this.secondaryposition,
          COLLECTOR: this.collector,
          ROLESTARTDATE: this.startDate,
          ROLEENDDATE: this.endDate,
          ROLEUSERIDUPDATE: userData.USER_ID,
        };

        // console.log("UPDATE DATA : ", data);

        this.$http
          .post("/structure/role/update", data, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res);
            // console.log(res);
            if (res.data.success) {
              this.isLoading = false;
              this.$router.push({
                name: "RoleOverview",
              });
            } else {
              this.isLoading = false;
              this.showSnackbar(res.data.message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.showSnackbar(err.toString());
          });
      } else {
        const {
          position,
          type,
          branch,
          supervisor,
          additionalType,
          startDate,
          endDate,
        } = this;

        if (position && type && branch && startDate && endDate) {
          const data = {
            rolePosCode: this.position,
            typeId: this.type.EMPLOYEE_TYPE_ID,
            typeCode: this.type.EMPLOYEE_TYPE_CODE,
            titleId: this.title.EMPLOYEE_TITLE_ID,
            titleCode: this.title.EMPLOYEE_TITLE_CODE,
            orgId: this.branch.ORG_ID,
            branchCode: this.branch.BRANCH_CODE,
            CSOCode: this.CSOCode.ROLE_POSITION_CODE
              ? this.CSOCode.ROLE_POSITION_CODE
              : "NA",
            supCode: this.supervisor.ROLE_POSITION_CODE
              ? this.supervisor.ROLE_POSITION_CODE
              : "NA",
            emailSup: this.emailSupervisor ? this.emailSupervisor : "NA",
            secondaryPosition: this.secondaryposition,
            roleAddType: this.additionalType ? this.additionalType : "NA",
            startDate: this.startDate,
            collector: this.collector,
            endDate: this.endDate,
            userIdUpdate: userData.USER_ID,
          };

          // console.log(data);

          this.$http
            .post("/structure/role/insert", data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              console.log(res);
              if (res.data.success) {
                this.isLoading = false;
                this.$router.push({
                  name: "RoleOverview",
                });
              } else {
                this.isLoading = false;
                this.showSnackbar(res.data.message);
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
        } else {
          this.isLoading = false;
          this.showSnackbar("All Field Must Filled");
        }
      }
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
